export interface ISortOption {
  value: string;
  label: string;
}

export interface ISortOptions {
  firstPublicationDateASC: ISortOption;
  firstPublicationDateDESC: ISortOption;
}

export const sortOptions: ISortOptions = {
  firstPublicationDateASC: {
    label: 'Earlier first',
    value: 'firstPublicationDateASC',
  },
  firstPublicationDateDESC: {
    label: 'New first',
    value: 'firstPublicationDateDESC',
  },
};
